var map = {
	"./15_happy.mp3": "bb1c",
	"./16_sad.mp3": "b22e",
	"./17_calm.mp3": "95af",
	"./18_angry.mp3": "1c2b",
	"./19_sleepy.mp3": "b5a1",
	"./20_hungry.mp3": "b89e",
	"./21_scared.mp3": "611b",
	"./22_mummy.mp3": "87a1",
	"./23_daddy.mp3": "c476",
	"./24_sister.mp3": "0c0b",
	"./25_brother.mp3": "4856",
	"./26_baby.mp3": "6627",
	"./27_grandma.mp3": "ea7f",
	"./28_grandpa.mp3": "ea12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ad7";